export default __webpack_public_path__ + "static/media/angle-bottom-left.18bb60ea.png";